import { z } from 'zod';
import { uuid, isoDateTime } from './common.js';
const hhmm = z.string().regex(/^\d{2}:\d{2}$/);
const isoDay = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
/**
 * Regra de repetição de uma série. O dia da semana (ou do mês) vem da primeira data (`startDay`), então a regra só
 * diz "de quanto em quanto": semanal a cada N semanas; mensal no mesmo dia da semana (1ª a 4ª ou última, -1);
 * mensal no mesmo dia do mês (29/30/31 em mês curto viram "ajuste" na prévia, nunca em silêncio).
 */
export const seriesRuleSchema = z.discriminatedUnion('freq', [
    z.object({ freq: z.literal('WEEKLY'), interval: z.number().int().min(1).max(8).default(1) }),
    z.object({ freq: z.literal('MONTHLY_WEEKDAY'), nth: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(-1)]) }),
    z.object({ freq: z.literal('MONTHLY_DAY') }),
]);
export const SERIES_MAX_OCCURRENCES = 52;
export const SERIES_MAX_MONTHS = 12;
export const seriesEndSchema = z.discriminatedUnion('by', [
    z.object({ by: z.literal('COUNT'), count: z.number().int().min(1).max(SERIES_MAX_OCCURRENCES) }),
    z.object({ by: z.literal('DATE'), until: isoDay }),
]);
export const SeriesStatus = { ACTIVE: 'ACTIVE', ENDED: 'ENDED', CANCELLED: 'CANCELLED' };
/** Decisão por ocorrência na criação: marcar, pular, ou encaixar (razões sobrescrevíveis vistas na prévia). */
export const SeriesDecision = { BOOK: 'BOOK', SKIP: 'SKIP', FIT_IN: 'FIT_IN' };
const addressSchema = z.object({ line: z.string().max(200), number: z.string().max(20).optional(), complement: z.string().max(80).optional(), district: z.string().max(80).optional(), city: z.string().max(80).optional(), state: z.string().max(40).optional(), postalCode: z.string().max(20).optional() });
/** Parâmetros da série (prévia e criação). */
export const seriesParamsSchema = z.object({
    clientId: uuid.optional(),
    newClient: z.object({ name: z.string().trim().min(2).max(120), phone: z.string().trim().min(8).max(32) }).optional(),
    memberId: uuid,
    serviceIds: z.array(uuid).min(1).max(5),
    startDay: isoDay,
    time: hhmm,
    rule: seriesRuleSchema,
    end: seriesEndSchema,
    modality: z.enum(['LOCAL', 'HOME']).default('LOCAL'),
    regionId: uuid.nullable().optional(),
    address: addressSchema.nullable().optional(),
    notes: z.string().max(1000).nullable().optional(),
});
/** Decisão de uma ocorrência na criação; `startsAt` pode ser outro horário do mesmo dia (sugestão aceita). */
export const seriesOccurrenceDecisionSchema = z.object({
    index: z.number().int().min(1).max(SERIES_MAX_OCCURRENCES),
    startsAt: isoDateTime,
    decision: z.enum(['BOOK', 'SKIP', 'FIT_IN']),
});
export const seriesCreateSchema = seriesParamsSchema.extend({ occurrences: z.array(seriesOccurrenceDecisionSchema).min(1).max(SERIES_MAX_OCCURRENCES) });
//# sourceMappingURL=series.js.map